import type { FaireProductEntity } from "../../entity_types/product";

export const p_xd3r5wpjwh: FaireProductEntity = {
  token: "p_xd3r5wpjwh",
  type: "product",
  name: "Sleep Blend Sp-17",
  brandToken: "b_jbqfywxgpa",
  brandName: "Solaray",
  imageUrl: "https://cdn.faire.com/fastly/216696bef98ff38e1104a80719b500924f87a8ca2e7816438ac91e442b96cdb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81d8273c20cf2375948b6f92b59ab437a5c02823c7bd3a46eb59a2e5c8abd304.png"
  ],
  priceDollars: 6.4,
  description: "Like you, Solaray appreciates hard work and a mind racing with new ideas. But when the lights go out, we all need some peaceful rest. That's why Solaray is excited to introduce our herbal Sleep Blend SP-17\n\nOur powerful formula includes a proprietary blend of Valerian, Hops, Skullcap, Passion Flower, Dandelion, Chamomile, Marshmallow, and Hawthorn. The powerful herbs in our Sleep Blend SP-17 contain key compounds and phytochemicals including linarin, valerenic acid, flavonoids, and more that may work together to support feelings of calmness and relaxation. We've also included cell salt nutrients formulated to work synergistically with the herbs in our Sleep Blend for added benefit.\n\nOur Sleep Blend is non-GMO, vegan and lab verified for potency, purity and identity. Give your mind the break so you can wake up, rested, to Live Brighter!",
  tags: [],
  msrpDollars: 12.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:13.722Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
